module.exports = __webpack_public_path__ + "static/media/illustration_banner.ad8cf308.png";